export default "/assets/images/filter-02.db7acc5e17f700a4.svg";